import { Button } from "@mui/material"
import { Secure } from "lib/authorization/secure"
import Iconify from "minimals-template/components/Iconify"
import { ProjectDialog } from "./project-dialog"
import { useDialog } from "lib/@hooks/useDialog"
import { createProject } from "../controller/create-project"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { navigate } from "lib/routes/navigate"
import { AUTHORING_MANAGE_WORK_PACKAGES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function AddProject({ variant = "contained" }) {
    const addProjectDialog = useDialog(<ProjectDialog />)
    return (
        <Secure demand={AUTHORING_MANAGE_WORK_PACKAGES_DEMAND} fallback={<></>}>
            <Button
                onClick={addProject}
                variant={variant}
                startIcon={<Iconify icon={"ic:round-add"} />}
                data-cy="add-project-button"
            >
                Add Work Package
            </Button>
        </Secure>
    )

    async function addProject() {
        try {
            const project = await addProjectDialog()
            if (project) {
                const newProject = await createProject(project)
                if (newProject) {
                    successSnackbar(`${newProject?.name} successfully created`)
                    navigateToProject(newProject?.id)
                } else {
                    errorSnackbar("Failed to create work package")
                }
            }
        } catch (e) {
            errorSnackbar(e.message)
        }
    }
}

function navigateToProject(projectId) {
    navigate(`/authoring/projects/${projectId}`)
}
